import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { cn } from '../../lib/utils';

const DataTable = ({ columns, data, onRowClick, emptyMessage = "No data available" }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-muted-foreground">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-border/40 overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-muted/50 hover:bg-muted/50">
            {columns.map((column, idx) => (
              <TableHead 
                key={idx} 
                className={cn("font-semibold text-foreground", column.className)}
              >
                {column.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row, rowIdx) => (
            <TableRow 
              key={rowIdx}
              className={cn(
                "transition-colors",
                onRowClick && "cursor-pointer hover:bg-accent/50"
              )}
              onClick={() => onRowClick?.(row)}
            >
              {columns.map((column, colIdx) => (
                <TableCell key={colIdx} className={column.cellClassName}>
                  {column.cell ? column.cell(row) : row[column.accessor]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default DataTable;
